<template>
  <div>
    <div v-if="isLoading">Loading data...</div>
    <ResultForm v-else :data="data" @save="save"></ResultForm>
  </div>
</template>
<script>
import LottoService from "@/services/lottoService"

import ResultForm from "./ResultForm.vue"

//import moment from "moment"

export default {
  components: {
    ResultForm
  },
  data() {
    return {
      resultData: null,
      isLoading: false,
      lotto: {
        lotto_date: '',
        start_spin: '',
        show_1st: '',
        show_2nd: '',
        results: {
          prize_1st: '',
          prize_2nd: '',
          prize_3rd_1: '',
          prize_3rd_2: '',
          prize_3rd_3: '',
          special_1: '',
          special_2: '',
          special_3: '',
          special_4: '',
          special_5: '',
          special_6: '',
          special_7: '',
          special_8: '',
          consolation_1: '',
          consolation_2: '',
          consolation_3: '',
          consolation_4: ''
        }
      }
    }
  },
  computed: {
    data() {
      return this.lotto
    }
  },
  methods: {
    loadResult() {
      this.isLoading = true
      LottoService.getResult(this.$route.params.resultId).then((response) => {
        if (response.status === 'success') {
          this.resultData = response.data
          this.lotto.lotto_date = this.resultData.lotto_date
          this.lotto.start_spin = this.resultData.start_spin
          this.lotto.show_1st = this.resultData.show_1st
          this.lotto.show_2nd = this.resultData.show_2nd
          this.lotto.results = this.resultData.results
          this.isLoading = false
        } else {
          this.$router.push({ name: 'admin-results' })
        }
      })
    },
    save(data) {
      LottoService.updateResult(this.$route.params.resultId, data).then((response) => {
        try {
          if (response.status === 'success') {
            this.$vs.notify({
              title: 'สำเร็จ!',
              text: 'บันทึกผลหวยเสร็จเรียบร้อย',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success'
            });

            this.$router.push({ name: 'admin-results' })
          } else {
            this.$vs.notify({
              title: 'ผิดพลาด!',
              text: 'บันทึกผลหวยไม่สำเร็จ',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            });
          }
        } catch (e) {
          this.$vs.notify({
            title: 'ผิดพลาด(2)!',
            text: 'บันทึกผลหวยไม่สำเร็จ',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        }
      })
    }
  },
  created() {
    this.loadResult()
  }
}

</script>
